'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _cookie = require('./cookie');

var _cookie2 = _interopRequireDefault(_cookie);

var _wsHistory = require('./ws-history');

var _wsHistory2 = _interopRequireDefault(_wsHistory);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
用于规范化读取aliexpress网站cookie
所有前端代码通过此对象读写cookie，老的逻辑废弃，所有cookie由此对象统一维护
@date 2014-11-25
@author qingguang.meiqg

当前维护的cookie列表
1. aep_usuc_f
    site:       分站
    region:     物流地点国家
    province:   物流地点省份
    city:       物流地点城市
    c_tp:       货币
    b_locale :   buyer买家语种
    s_locale:   seller卖家语种
    iss:        是否卖家用户
    isb:        是否买家用户(可能既是买家又是卖家)
    ispm:       是否付费用户
    isfm:       是否免费用户
    isks:       是否KA卖家用户，具体业务逻辑咨询 @王康栋
    isgcl:      是否是绿色通道用户，具体业务逻辑咨询 @王康栋
    reg_ver:    注册灰度版本 new/old
    getBerLFg:  会员等级
    zero_order: 未下单的零单用户
    ae_u_p_s:   0:是欧盟国家 1:不同意网站获取用户个人信息  2:同意网站获取用户信息，做个性化推荐  针对欧盟国家新增
    ups_u_t:    毫秒数 针对欧盟国家新增，记录用户操作时间（当前时间+13个月），达到这个时间后，需要在提示给用户操作


2. xman_us_f
    x_locale:   国家地区（不再新增逻辑，即将废弃）
    x_l:        是否海外用户1/0，1:国内，0:海外
    x_user:     用户信息，格式{地区}|{firstName}|{lastName}|{serviceType}|{memberSeq}，例如:US|mei|kidd|ifm|101555804

3. xman_us_t
    sign:       用户是否登录 y/n


TODO
1 history是否迁移
2 aeTest读写
3 是否增加对encode的检测
*/

var WSCookie = function () {
    function WSCookie() {
        (0, _classCallCheck3.default)(this, WSCookie);
        this.siteFormat = /^[a-z]{3}(_[a-z]{1})?$/;
        this.x_localeFormat = /^[a-z]{2}_[A-Z]{2}$/;
        this.s_localeFormat = /^[a-z]{2}_[A-Z]{2}$/;
        this.b_localeFormat = /^[a-z]{2}_[A-Z]{2}$/;
        this.c_tpFormat = /^[A-Z]{3}$/;
        this.regionFormat = /^[A-Z]{2,3}$/;
        this.provinceFormat = /^[0-9]{18}$/;
        this.cityFormat = /^[0-9]{18}$/;
        this.siFormat = /^(glo|rus|bra|esp|idn|fra|deu|ita)$/;
        this.signFormat = /^(y|n)$/;
        this.x_userFormat = /^.*$/;
        this.issFormat = /^(y)$/;
        this.isbFormat = /^(y)$/;
        this.ispmFormat = /^(y)$/;
        this.isksFormat = /^(y)$/;
        this.isgclFormat = /^(y)$/;
        this.reg_verFormat = /^(new|old)$/;
        this.x_lFormat = /^[01]{1}$/;
        this.ber_lFormat = /^A\d$/;
        this.zero_orderFormat = /^(y)$/;
        this.ae_u_p_sFormat = /^[012]{1}$/;
        this.ups_u_tFormat = /^[0-9]{13,}$/;
        this.x_csrfFormat = /^.*$/;
    } // Site格式：glo/glo_b/glo_t

    // locale格式：en_US/ru_RU/pt_BR

    // locale格式：en_US/ru_RU/pt_BR

    // locale格式：en_US/ru_RU/pt_BR

    // 货币格式：USD/RUB/BRL

    // region格式：US/RU/BR

    // province格式：18位数字

    // city格式：18位数字

    // m站的site

    // 用户是否登录

    // 用户信息，由于包含了用户名等自定义信息，格式无法确定

    // 是否卖家seller

    // 是否买家buyer

    // 是否付费用户PremiumMember

    // 是否KA买家用户

    // 是否绿色通道用户

    // 注册版本

    // 是否海外用户

    // 会员等级 A0,A1

    // 是否是未下单的用户

    // 欧盟国家相关信息

    // 毫秒数

    (0, _createClass3.default)(WSCookie, [{
        key: 'get',
        // csrf token

        value: function get(name, options) {
            return _cookie2.default.get(name, options);
        }

        /**
         * An interface for writing cookie
         *
         * @param name {String}: cookie name
         *      2 available values:aep_usuc_f, xman_us_f
         *
         * @param key {String}: cookie key
         *      6 available values:site, region, c_tp, x_locale, b_locale, s_locale
         *
         * @param value {String}: cookie value
         *
         */

    }, {
        key: '_setcookie',
        value: function _setcookie(name, key, value) {
            // 允许在cookie里设置空的value
            if (value && !this.validate(key, value)) {
                return false;
            }

            // 获取cookie
            var cookieStr = _cookie2.default.get(name, {
                domain: 'aliexpress.com',
                path: '/',
                raw: true
            }) || '';

            // 改写cookie
            var cookieRegExp = new RegExp('(.*&?' + key + '=)(.*?)(&.*|$)');
            if (cookieRegExp.test(cookieStr)) {
                // 将cookie值替换为新值
                cookieStr = RegExp.$1 + value + RegExp.$3;
            } else {
                // 原cookie中没有这个key，在cookie的末尾新增key=value
                cookieStr = (cookieStr ? cookieStr + '&' : '') + (key + '=' + value);
            }

            // 写入cookie
            _cookie2.default.set(name, cookieStr, {
                domain: 'aliexpress.com',
                path: '/',
                expires: 365 * 10,
                raw: true
            });
        }
    }, {
        key: '_getCookie',
        value: function _getCookie(name, key) {
            var cookieStr = _cookie2.default.get(name, {
                domain: 'aliexpress.com',
                path: '/',
                raw: true // 原样取出cookie，不decode
            }) || '';

            // 正则表达式，用于匹配出cookie值
            var cookieRegExp = new RegExp('(.*&?' + key + '=)(.*?)(&.*|$)');
            cookieStr.match(cookieRegExp);

            // $1：'key='及前面的部分
            // $2：value
            // $3：value值后面的部分
            var value = RegExp.$2;
            if (cookieRegExp.test(cookieStr) && this.validate(key, value)) {
                return value;
            } else {
                return '';
            }
        }
    }, {
        key: 'validate',
        value: function validate(key, value) {
            // 包含关键分隔符 = 和 &
            if (/(&|=)/.test(value)) return false;

            // cookie格式校验
            if (value && this[key + 'Format'] && this[key + 'Format'].test(value)) {
                return true;
            } else {
                return false;
            }
        }

        /* M站 分站，注意是在m.aliexpress.com域下 */

    }, {
        key: 'getMSite',
        value: function getMSite(name, key) {
            var cookieStr = _cookie2.default.get(name, {
                domain: 'm.aliexpress.com',
                path: '/',
                raw: true // 原样取出cookie，不decode
            }) || '';

            // 正则表达式，用于匹配出cookie值
            var cookieRegExp = new RegExp('(.*&?' + key + '=)(.*?)(&.*|$)');
            cookieStr.match(cookieRegExp);

            // $1：'key='及前面的部分
            // $2：value
            // $3：value值后面的部分
            var value = RegExp.$2;
            if (cookieRegExp.test(cookieStr) && this.validate(key, value)) {
                return value;
            } else {
                return '';
            }
        }

        /* aep_usuc_f:site */

    }, {
        key: 'setSite',
        value: function setSite(site) {
            this._setcookie('aep_usuc_f', 'site', site);
        }
    }, {
        key: 'getSite',
        value: function getSite() {
            return this._getCookie('aep_usuc_f', 'site');
        }

        /* aep_usuc_f:region */

    }, {
        key: 'setRegion',
        value: function setRegion(region) {
            this._setcookie('aep_usuc_f', 'region', region);
        }
    }, {
        key: 'getRegion',
        value: function getRegion() {
            return this._getCookie('aep_usuc_f', 'region');
        }

        /* aep_usuc_f:province */

    }, {
        key: 'setProvince',
        value: function setProvince(province) {
            this._setcookie('aep_usuc_f', 'province', province);
        }
    }, {
        key: 'getProvince',
        value: function getProvince() {
            return this._getCookie('aep_usuc_f', 'province');
        }

        /* aep_usuc_f:city */

    }, {
        key: 'setCity',
        value: function setCity(city) {
            this._setcookie('aep_usuc_f', 'city', city);
        }
    }, {
        key: 'getCity',
        value: function getCity() {
            return this._getCookie('aep_usuc_f', 'city');
        }

        /* aep_usuc_f:c_tp */

    }, {
        key: 'setCurrency',
        value: function setCurrency(currency) {
            this._setcookie('aep_usuc_f', 'c_tp', currency);
        }
    }, {
        key: 'getCurrency',
        value: function getCurrency() {
            return this._getCookie('aep_usuc_f', 'c_tp');
        }

        /* xman_us_f:x_locale */
        /* 注意：此方法废弃，请不要再使用 */

    }, {
        key: 'setLocale',
        value: function setLocale(locale) {
            this._setcookie('xman_us_f', 'x_locale', locale);
        }

        /* 注意：此方法废弃，请不要再使用 */

    }, {
        key: 'getLocale',
        value: function getLocale() {
            return this._getCookie('xman_us_f', 'x_locale');
        }

        /*
            aep_usuc_f:s_locale
            卖家locale语种
        */

    }, {
        key: 'setSellerLocale',
        value: function setSellerLocale(locale) {
            // 写入intl_locale cookie，此cookie只有卖家后台在用
            _cookie2.default.set('intl_locale', locale, {
                domain: 'aliexpress.com',
                path: '/',
                expires: 365, // cookie 保留 1 年
                raw: true
            });
            // 写入x_locale
            this.setLocale(locale);
            // 写入s_locale
            this._setcookie('aep_usuc_f', 's_locale', locale);
        }
    }, {
        key: 'getSellerLocale',
        value: function getSellerLocale() {
            return this._getCookie('aep_usuc_f', 's_locale');
        }

        /*
            aep_usuc_f:b_locale
            买家locale语种
        */

    }, {
        key: 'setBuyerLocale',
        value: function setBuyerLocale(locale) {
            // 写入x_locale
            this.setLocale(locale);
            // 写入b_locale
            this._setcookie('aep_usuc_f', 'b_locale', locale);
        }
    }, {
        key: 'getBuyerLocale',
        value: function getBuyerLocale() {
            return this._getCookie('aep_usuc_f', 'b_locale');
        }

        /*
            xman_us_t:sign
            用于判断用户是否登录sign=y/n
        */

    }, {
        key: 'getSign',
        value: function getSign() {
            return this._getCookie('xman_us_t', 'sign');
        }
    }, {
        key: 'isLoggedIn',
        value: function isLoggedIn() {
            if (this.getSign() == 'y') {
                return true;
            } else {
                return false;
            }
        }

        /*
            aep_usuc_f:iss
            用于判断用户是否卖家iss=y
        */

    }, {
        key: 'getIss',
        value: function getIss() {
            return this._getCookie('aep_usuc_f', 'iss');
        }
    }, {
        key: 'isSeller',
        value: function isSeller() {
            if (this.getIss() === 'y') {
                return true;
            } else {
                return false;
            }
        }

        /*
            aep_usuc_f:isb
            用于判断用户是否买家 isb=y
        */

    }, {
        key: 'getIsb',
        value: function getIsb() {
            return this._getCookie('aep_usuc_f', 'isb');
        }
    }, {
        key: 'isBuyer',
        value: function isBuyer() {
            if (this.getIsb() === 'y') {
                return true;
            } else {
                return false;
            }
        }

        /*
            aep_usuc_f:isks
            用于判断是否KA卖家用户 isks=y
        */

    }, {
        key: 'getIsks',
        value: function getIsks() {
            return this._getCookie('aep_usuc_f', 'isks');
        }
    }, {
        key: 'isKaSeller',
        value: function isKaSeller() {
            if (this.getIsks() === 'y') {
                return true;
            } else {
                return false;
            }
        }

        /*
            aep_usuc_f:isgcl
            用于判断是否绿色通道用户 isgcl=y
        */

    }, {
        key: 'getIsgcl',
        value: function getIsgcl() {
            return this._getCookie('aep_usuc_f', 'isgcl');
        }
    }, {
        key: 'isGreenChannel',
        value: function isGreenChannel() {
            if (this.getIsgcl() === 'y') {
                return true;
            } else {
                return false;
            }
        }

        /*
            aep_usuc_f:ispm
            用于判断用户是否付费用户ispm=y
        */

    }, {
        key: 'getIspm',
        value: function getIspm() {
            return this._getCookie('aep_usuc_f', 'ispm');
        }
    }, {
        key: 'isPremiumMember',
        value: function isPremiumMember() {
            if (this.getIspm() === 'y') {
                return true;
            } else {
                return false;
            }
        }

        /*
            aep_usuc_f:isfm
            用于判断用户是否免费用户isfm=y
        */

    }, {
        key: 'getIsfm',
        value: function getIsfm() {
            return this._getCookie('aep_usuc_f', 'isfm');
        }
    }, {
        key: 'isFreeMember',
        value: function isFreeMember() {
            if (this.getIsfm() === 'y') {
                return true;
            } else {
                return false;
            }
        }

        /*
            aep_usuc_f:reg_ver
            用于判断注册版本 new/old
        */

    }, {
        key: 'getRegVer',
        value: function getRegVer() {
            return this._getCookie('aep_usuc_f', 'reg_ver');
        }

        /*
            xman_us_f:x_l
            用于判断是否海外用户x_l=0/1
        */

    }, {
        key: 'getOversea',
        value: function getOversea() {
            return this._getCookie('xman_us_f', 'x_l');
        }
    }, {
        key: 'isOversea',
        value: function isOversea() {
            if (this.getOversea() === '1') {
                return false;
            } else {
                return true;
            }
        }

        /*
            xman_us_f:x_user
            用于获取用户信息
            @return {Object}
            例如:{
                    country:US,
                    firstName:mei,
                    lastName:kidd,
                    memberSeq:184851016,
                }
        */

    }, {
        key: '_getXUserRaw',
        value: function _getXUserRaw() {
            return this._getCookie('xman_us_f', 'x_user');
        }
    }, {
        key: 'getXUserObj',
        value: function getXUserObj() {
            var xuserObj = {
                country: '',
                firstName: '',
                lastName: '',
                memberSeq: ''
            };
            var xuserStr = this._getXUserRaw() || '';
            var xuserArr = xuserStr.split('|');

            if (xuserArr.length >= 5) {
                xuserObj.country = xuserArr[0];
                xuserObj.firstName = xuserArr[1].replace(/</g, '&lt;').replace(/>/g, '&gt;');
                xuserObj.lastName = xuserArr[2].replace(/</g, '&lt;').replace(/>/g, '&gt;');
                // xuserObj.serviceType = xuserArr[3]; //废弃serviceType
                xuserObj.memberSeq = xuserArr[4];
            }
            return xuserObj;
        }

        /**
         * 获取账户
         */

    }, {
        key: 'getMemberSeq',
        value: function getMemberSeq() {
            return this.getXUserObj().memberSeq;
        }

        /**
         * 是否是新用户
         */

    }, {
        key: 'isNewUser',
        value: function isNewUser() {
            if (this.getXUserObj().memberSeq !== '') {
                return false;
            } else {
                return true;
            }
        }

        /**
         * aep_history 此cookie纯前端使用
         * 记录一个产品id
         * @param productId {String} 产品id
         */

    }, {
        key: 'setHistory',
        value: function setHistory(productId) {
            if (!productId) return;
            _wsHistory2.default.logProduct({
                id: productId
            });
        }

        /**
         * 获取最近访问过的商品 ID
         * @return ids {Array}
         */

    }, {
        key: 'getHistory',
        value: function getHistory() {
            return _wsHistory2.default.getProducts();
        }

        /**
         * aeTest 此cookie纯前端使用，运营场景用于ABtest
         */

    }, {
        key: 'setAETest',
        value: function setAETest() {
            // TODO
        }
    }, {
        key: 'getAETest',
        value: function getAETest() {
            // TODO
            return '';
        }

        /*
         * 用户等级
         * aep_usuc_t :ber_l
        */

    }, {
        key: 'getBerL',
        value: function getBerL() {
            return this._getCookie('aep_usuc_t', 'ber_l');
        }

        /* xman_us_f: zero_order */

    }, {
        key: 'getZeroOrder',
        value: function getZeroOrder() {
            return this._getCookie('xman_us_f', 'zero_order');
        }
    }, {
        key: 'isZeroOrderUser',
        value: function isZeroOrderUser() {
            if (this.getZeroOrder() === 'y') {
                return true;
            } else {
                return false;
            }
        }

        /*
         * 针对欧盟国家新增的cookie
         * 0:是欧盟国家 1:不同意网站获取用户个人信息  2:同意网站获取用户信息，做个性化推荐
        */

    }, {
        key: 'getAeUps',
        value: function getAeUps() {
            return this._getCookie('aep_usuc_f', 'ae_u_p_s');
        }
    }, {
        key: 'setAeUps',
        value: function setAeUps(value) {
            return this._setcookie('aep_usuc_f', 'ae_u_p_s', value);
        }

        /*
         * 针对欧盟国家新增的时间毫秒数
        */

    }, {
        key: 'getAeUpsTime',
        value: function getAeUpsTime() {
            return this._getCookie('aep_usuc_f', 'ups_u_t');
        }
    }, {
        key: 'setAeUpsTime',
        value: function setAeUpsTime(value) {
            return this._setcookie('aep_usuc_f', 'ups_u_t', value);
        }

        /**
         * 获取csrf token
         */

    }, {
        key: 'getCsrfToken',
        value: function getCsrfToken() {
            var csrfToken = this._getCookie('acs_usuc_t', 'x_csrf');

            // 测试一下错误率，后续可以删掉
            if (!csrfToken) {
                if (window.__bl && window.__bl.api) {
                    window.__bl.error(new Error('Cookie.getCsrfToken error'));
                } else if (window.__bl) {
                    window.__bl.pipe = window.__bl.pipe || [];
                    window.__bl.pipe.push(['error', new Error('Cookie.getCsrfToken error')]);
                }
            }

            return csrfToken;
        }
    }]);
    return WSCookie;
}();

exports.default = new WSCookie();